import { api } from "lib/graphql/api"
import { mutate } from "lib/graphql/mutate"
import { gql } from "@apollo/client"

export const recalculateVariant = api(async function recalculateVariant({ scenarioId, variantId }) {
    return mutate(
        gql`
            mutation RecalculateVariant($scenarioId: String!, $variantId: String!) {
                recalculateVariant(scenarioId: $scenarioId, variantId: $variantId)
            }
        `,
        { scenarioId, variantId },
        { returns: "recalculateVariant" }
    )
})
